import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { EmployeeCategory } from '../../shared/models/EmployeeCategory/EmployeeCategory';
import { NotificationService } from '../../core/services/notification.service';

@Injectable()
export class EmployeeCategoriesService extends DataService<EmployeeCategory> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = "employeecategory";
	}

}